/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLadderRegular: {
  name: 'ladder-regular';
  data: string;
} = {
  name: 'ladder-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.673 2.063a.94.94 0 0 0-.366.236C5.971 2.635 6 1.726 6 12c0 10.273-.029 9.365.306 9.7.18.179.458.3.694.3.237 0 .514-.12.697-.303.281-.281.303-.4.303-1.644V19h8v1.073c0 1.242.018 1.339.306 1.627.18.179.458.3.694.3.402 0 .827-.312.939-.69.054-.18.061-1.275.061-9.31s-.007-9.13-.061-9.31C17.827 2.312 17.402 2 17 2c-.236 0-.514.121-.694.3-.288.288-.306.385-.306 1.627V5H8V3.947c0-1.244-.022-1.363-.303-1.644-.279-.279-.63-.361-1.024-.24M16 8v1H8V7h8zm0 4v1H8v-2h8zm0 4v1H8v-2h8z"/></svg>`
};
